import type { Assistant, AssistantFeature } from './types';
import { cabinConfigAssistant, cabinConfigFeature } from './cabinConfig';
import { crewSalaryAssistant, crewSalaryFeature } from './crewSalary';
import { engineeringAssistant, flightSpeedFeature } from './flightSpeed';
import { financialAssistant, listingFeature } from './financial';

export const ASSISTANTS: Assistant[] = [
  engineeringAssistant,
  cabinConfigAssistant,
  crewSalaryAssistant,
  financialAssistant,
];

export const ASSISTANT_FEATURES: AssistantFeature[] = [
  flightSpeedFeature,
  cabinConfigFeature,
  crewSalaryFeature,
  listingFeature,
];

export function assistantById(id: string): Assistant | undefined {
  return ASSISTANTS.find((a) => a.id === id);
}

export function featureById(id: string): AssistantFeature | undefined {
  return ASSISTANT_FEATURES.find((f) => f.id === id);
}
